import { extension, PlainExtension } from '@remirror/core';
import { trailingNode } from '@remirror/pm/trailing-node';

var _dec, _class;
var TrailingNodeExtension = (_dec = extension({
  defaultOptions: {
    ignoredNodes: [],
    disableTags: false,
    nodeName: 'paragraph'
  }
}), _dec(_class = class TrailingNodeExtension extends PlainExtension {
  get name() {
    return 'trailingNode';
  }
  /**
   * Whenever the options are changed make sure to update the plugin with the
   * new values and trigger a state update.
   */


  onSetOptions(props) {
    var changes = props.changes;

    if (changes.disableTags.changed || changes.ignoredNodes.changed || changes.nodeName.changed) {
      this.store.updateExtensionPlugins(this);
    }
  }
  /**
   * Add the trailing node plugin to the editor.
   */


  createExternalPlugins() {
    var tags = this.store.tags;
    var _this$options = this.options,
        disableTags = _this$options.disableTags,
        nodeName = _this$options.nodeName; // The names of the nodes for which this rule should not be applied.

    var ignoredNodes = disableTags ? [...this.options.ignoredNodes] : [...this.options.ignoredNodes, ...tags.lastNodeCompatible];
    return [trailingNode({
      ignoredNodes,
      nodeName
    })];
  }

}) || _class);

export { TrailingNodeExtension };
